import React from "react";
import styled from "styled-components";
import Navbar from "./Navbar";
import TopBar from "./TopBar";
import { PageHeaderBackdrop, StickyHeader } from "./Header.styles";

const SiteHeader = ({
  children,
  className,
  isScrolled = false,
  onNavigate,
}) => (
  <>
  <div className="print-only" data-print-header>
    National Minorities Development and Finance Corporation (NMDFC)
  </div>
  <StickyHeader data-site-header data-print-hide $isScrolled={isScrolled} className={className}>
    <TopBar />
    <PageHeaderBackdrop>
      <Navbar embeddedInHeaderBackdrop onNavigate={onNavigate} />
      {children ? <HeaderContent>{children}</HeaderContent> : null}
    </PageHeaderBackdrop>
  </StickyHeader>
  </>
);

const HeaderContent = styled.div`
  position: relative;
  z-index: 1;
  min-width: 0;
  max-width: 100%;
  padding-top: 36px;

  @media (max-width: 1280px) {
    padding-top: 0;
  }
`;

export default SiteHeader;
